<pos-app-spinner [show]="(loadingFetchingOrderFromJDE$ | async) || (isBusy$ | async)"></pos-app-spinner>
<form [formGroup]="searchTaskForm">
  <div class="row m-2">
    <div class="col-12 d-flex justify-content-between flex-wrap" style="background-color: rgb(236, 234, 234)">
      <ul class="nav nav-tabs w-100">
        <li class="nav-item d-flex justify-content-start" *ngFor="let nav of notificationNavs; let i = index">
          <a
            class="nav-link"
            [ngClass]="{ active: activeNavIndex === i, inactive: activeNavIndex !== i }"
            [style.color]="activeNavIndex === i ? 'black' : 'grey'"
            (click)="setActiveNavClick(i)"
            href="javascript:void(0)"
          >
            <span *ngIf="nav.badgeCount > 0" class="badge bg-primary me-2">{{ nav.badgeCount }}</span>
            {{ nav.label }}
          </a>
        </li>
        <li class="nav-item ms-auto">
          <button class="btn btn-secondary" (click)="showAdvanceFilter()">
            ADVANCED SEARCH
            <mat-icon style="height: 20px; width: 20px">{{ isShowAdvanceFilter ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
          </button>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="isShowAdvanceFilter" class="border mx-2 p-2">
    <div class="d-flex justify-content-center flex-wrap" style="background-color: rgb(236, 234, 234)">
      <label class="p-2 text-uppercase"> ADVANCED SEARCH</label>
    </div>
    <div class="row p-2">
      <div class="col-md-3">
        <label for="filterBySite">Source Site</label>
        <ng-select id="filterBySite" formControlName="sourceSite" placeholder="Select Site" [clearable]="true">
          <ng-option *ngFor="let site of siteList" [value]="site.siteCode">{{ site.siteDescription }} ({{ site.siteCode }})</ng-option>
        </ng-select>
      </div>
      <div class="col-md-3">
        <label for="filterByAssignedSite">Assigned Site</label>
        <ng-select id="filterByAssignedSite" formControlName="assignedSite" placeholder="Select Site" [clearable]="true">
          <ng-option *ngFor="let site of siteList" [value]="site.siteCode">{{ site.siteDescription }} ({{ site.siteCode }})</ng-option>
        </ng-select>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filterByRaisedPerson">Raised By</label>
          <ng-select placeholder="Select Site" formControlName="raisedBy" [clearable]="true">
            <ng-option *ngFor="let salesperson of salesPersonList" [value]="salesperson.userEmail">{{ salesperson.name }} </ng-option>
          </ng-select>
        </div>
      </div>
      <div *ngIf="!isExternalUser && !isProgrammeUser" class="col-md-3">
        <div class="form-group">
          <label for="filterByCustomer">Customer</label>
          <pos-app-lib-customer-search
            (selectNewCustomer)="selectCustomer($event)"
            [disabled]="false"
            [selectedCustomerName]="searchTaskForm.get('customerNumber').value"
            [showSearchIcon]="true"
            placeHolder="SEARCH CUSTOMER TO SELECT"
            value="{{ selectedCustomerNumber }}"
            [removeCustomerAfterLoad]="false"
            [resetCustomer]="true"
          ></pos-app-lib-customer-search>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filterByCustomer">Order Number</label>
          <input type="text" formControlName="orderNumber" class="form-control" placeholder="Enter Order Number" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button *ngIf="isShowAdvanceFilter" class="btn btn-cancel border py-1" (click)="clearAdvanceSearch()">Clear All</button>

      <button type="button" class="btn text-uppercase" [disabled]="searchTaskForm.invalid" (click)="searchTask()">Search</button>
    </div>
  </div>
</form>

<div class="m-2">
  <ag-grid-angular
    #agGrid
    class="ag-theme-balham"
    [rowData]="rowData"
    [context]="context"
    [frameworkComponents]="frameworkComponents"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [domLayout]="'autoHeight'"
    [pagination]="true"
    [paginationPageSize]="20"
    [quickFilterText]="searchValue"
  ></ag-grid-angular>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">TASK ATTACHMENT</h3>
  </div>
  <div class="modal-body">
    <pos-app-attachment-files-notes
      [preloadAttachments]="taskDetail?.attachments"
      [entityId]="entityId"
      [entityType]="entityType"
      (closeActiveModal)="handleCloseModal($event)"
    ></pos-app-attachment-files-notes>
  </div>
</ng-template>
